import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
import { TrustBadges } from './TrustBadges';
import { checkoutUrl, productImage } from './constants';
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 30,
    seconds: 5
  });
  useEffect(() => {
    const timer = window.setInterval(() => setTimeLeft(previous => {
      if (previous.seconds > 0) return {
        ...previous,
        seconds: previous.seconds - 1
      };
      if (previous.minutes > 0) return {
        ...previous,
        minutes: previous.minutes - 1,
        seconds: 59
      };
      if (previous.hours > 0) return {
        hours: previous.hours - 1,
        minutes: 59,
        seconds: 59
      };
      return {
        hours: 1,
        minutes: 30,
        seconds: 5
      };
    }), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return <section id="offerta" className="py-4 px-4 sm:px-6 bg-white border-y-4 border-brand-gold/60 scroll-mt-2" data-id="element-89" data-mp="2xk9i4vqvbhzw">
      <div className="text-center mb-2" data-id="element-90" data-mp="2srggigqp4ps1">
        <p className="text-[11px] font-heading font-bold text-brand-pink uppercase tracking-widest" data-id="element-91" data-mp="32km0ood3enim">
          Offerta Speciale — Sistema Completo 6-in-1
        </p>
        <p className="text-[13px] font-semibold text-brand-slate mt-0.5 leading-snug" data-id="element-92" data-mp="37li30xhsq1lx">
          Accedi subito al sistema completo e rivoluziona il modo in cui prepari i tuoi allenamenti.
        </p>
        <p className="font-heading font-bold text-brand-plum text-sm sm:text-base mt-2 leading-tight" data-id="element-93" data-mp="2xrj3m693wvxo">
          🤸 RHYTHMIC GYM PRO™ — Sistema Completo 6-in-1 per Allenatori di Ginnastica Ritmica
        </p>
        <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="block mt-2" data-id="element-94" data-mp="2oqky1jj0sgcz">
          <img src={productImage} alt="Rhythmic Gym Pro — Sistema Completo 6-in-1" className="w-full max-w-[220px] mx-auto drop-shadow-lg" data-id="element-95" data-mp="29xrffp8gbk43" />
        </a>
      </div>
      <div className="bg-white border-4 border-brand-gold rounded-lg p-3.5 text-center shadow-xl" data-id="element-96" data-mp="82h1569pjz1c">
        <p className="text-[13px] font-semibold text-brand-slate" data-id="element-97" data-mp="bm7twfxfe8td">
          Prezzo di Listino: <span className="line-through" data-id="element-98" data-mp="bk4wvbxuvff5">97€</span>
        </p>
        <p className="text-[13px] font-heading font-bold text-brand-pinkDark uppercase leading-tight mt-0.5" data-id="element-99" data-mp="6md2mb9qnh7s">
          🔥 72% di sconto — Offerta di lancio a tempo limitato
        </p>
        <p className="text-xs font-heading font-bold text-brand-plum mt-1.5 uppercase" data-id="element-100" data-mp="3tsm361kr1ulf">
          Oggi Solo: <span className="text-4xl sm:text-5xl font-display tracking-wide align-middle" data-id="element-101" data-mp="ucz2hf9l9v6p">27€</span>
        </p>
        <p className="text-[10px] font-bold text-brand-slate/70 uppercase tracking-wider" data-id="element-102" data-mp="pexgomks3hrj">
          Pagamento sicuro nella tua valuta.
        </p>
        <div className="bg-brand-blushLight border border-brand-blush rounded p-2 my-3" data-id="element-103" data-mp="kkjkihyal6lt">
          <p className="text-[11px] font-bold text-brand-pinkDark uppercase leading-tight" data-id="element-104" data-mp="gjhrwjyvrsst">
            ⏳ Questa offerta terminerà allo scadere del conto alla rovescia.
          </p>
          <div className="flex items-start justify-center gap-1.5 mt-1.5" data-id="element-105" data-mp="18b74w2pe9op9">
            <TimeBox value={timeLeft.hours} label="ORE" data-id="element-106" data-mp="2r0josecwfz1m" />
            <span className="text-brand-plum font-bold text-lg leading-none" data-id="element-107" data-mp="2vy1ode5111wy">:</span>
            <TimeBox value={timeLeft.minutes} label="MINUTI" data-id="element-108" data-mp="2w0602i96357s" />
            <span className="text-brand-plum font-bold text-lg leading-none" data-id="element-109" data-mp="2zyd72ldtws5s">:</span>
            <TimeBox value={timeLeft.seconds} label="SECONDI" data-id="element-110" data-mp="3502i4111x5tv" />
          </div>
        </div>
        <CTAButton href={checkoutUrl} data-id="element-111" data-mp="39yvvzuk92yuk">🚀 SÌ! VOGLIO RHYTHMIC GYM PRO™ ORA</CTAButton>
      </div>
      <TrustBadges className="mt-2" data-id="element-112" data-mp="3ewdxx0zuodt2" />
    </section>;
}
function TimeBox({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <div className="text-center" data-id="element-113" data-mp="3jop7ywob1fzc">
      <div className="bg-brand-plum text-white text-lg font-heading font-bold px-2 py-1 rounded leading-none" data-id="element-114" data-mp="3np988946czpp">
        {String(value).padStart(2, '0')}
      </div>
      <p className="text-[8px] font-bold text-brand-slate mt-0.5" data-id="element-115" data-mp="3sqey7z6ga8vj">{label}</p>
    </div>;
}